import { useMemo } from "react";

/**
 * Global ambient layer: gentle fireflies floating across the whole page.
 * Lightweight pure-CSS — single fixed layer with absolute spans.
 */
export default function FairyAmbience({ count = 14 }) {
  const flies = useMemo(
    () => Array.from({ length: count }).map(() => ({
      left: Math.random() * 100,
      top: Math.random() * 100,
      delay: Math.random() * 8,
      duration: 7 + Math.random() * 7,
      size: 3 + Math.random() * 5,
    })),
    [count]
  );
  return (
    <div className="fixed inset-0 pointer-events-none z-[1] mix-blend-screen" aria-hidden="true">
      {flies.map((f, i) => (
        <span
          key={i}
          className="firefly"
          style={{
            left: `${f.left}%`,
            top: `${f.top}%`,
            width: `${f.size}px`,
            height: `${f.size}px`,
            animationDelay: `${f.delay}s`,
            animationDuration: `${f.duration}s`,
          }}
        />
      ))}
    </div>
  );
}
